function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#299D74"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.813 0c1.939 0 3.5 1.56 3.5 3.5S8.752 7 6.813 7c-1.94 0-3.5-1.56-3.5-3.5S4.873 0 6.813 0M4.408 8h5.809c2.244 0 4.092 1.75 4.092 3.875 0 .458.088 1.125-.616 1.125H.933c-.705 0-.617-.667-.617-1.125C.316 9.75 2.164 8 4.408 8",
  transform: "translate(-1130 -304) translate(1130.688 302) translate(0 2)"
})))));

function SvgOwnerRole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerRole);
export default __webpack_public_path__ + "static/media/owner-role.daa834bb.svg";
export { ForwardRef as ReactComponent };